// extracted by mini-css-extract-plugin
export var actionButton = "_rv-0";
export var actionMenuContainer = "_rv-i";
export var bubble = "_rv-2";
export var bubbleActionMenu = "_rv-j";
export var bubbleContext = "_rv-6";
export var bubbleItems = "_rv-7";
export var customer = "_rv-3";
export var divider = "_rv-8";
export var fileList = "_rv-9";
export var hiddenComment = "_rv-o";
export var infoAbove = "_rv-a";
export var internal = "_rv-4";
export var lightActionButton = "_rv-1";
export var link = "_rv-b";
export var merchant = "_rv-5";
export var message = "_rv-c";
export var profilePicture = "_rv-e";
export var quillToolbarContainer = "_rv-f";
export var senderDate = "_rv-g";
export var senderDateCustomer = "_rv-h";
export var senderName = "_rv-d";
export var time = "_rv-k";
export var uploadedImage = "_rv-l";
export var username = "_rv-m";
export var xsmall = "_rv-n";